import { render, staticRenderFns } from "./showRefresh-editor.vue?vue&type=template&id=f09519c4&scoped=true"
import script from "./showRefresh-editor.vue?vue&type=script&lang=js"
export * from "./showRefresh-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09519c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f09519c4')) {
      api.createRecord('f09519c4', component.options)
    } else {
      api.reload('f09519c4', component.options)
    }
    module.hot.accept("./showRefresh-editor.vue?vue&type=template&id=f09519c4&scoped=true", function () {
      api.rerender('f09519c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/showRefresh-editor.vue"
export default component.exports